var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MonacoEditor',{key:_vm.randomkey,attrs:{"code":_vm.code,"language":_vm.language,"editorOptions":_vm.options},on:{"mounted":_vm.onMounted,"codeChange":_vm.onCodeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }